module.exports = __webpack_public_path__ + "img/qr-android-en-app-logo.4a90edee.png";